import dayjs from 'dayjs';
import { PickEnum } from 'utils/helpers/typsecript';
import { EAdvancedCouponsLayouts } from 'interfaces/sportsbook';

export type TFilteredCouponLayoutsForRanges = PickEnum<
  EAdvancedCouponsLayouts,
  EAdvancedCouponsLayouts.todayMatches | EAdvancedCouponsLayouts.tomorrowMatches
>;

export const TIME_RANGES_BY_COUPON_LAYOUT: Record<
  TFilteredCouponLayoutsForRanges,
  { '@gte': number; '@lte': number }
> = {
  [EAdvancedCouponsLayouts.todayMatches]: {
    '@gte': dayjs().startOf('day').unix(),
    '@lte': dayjs().endOf('day').unix()
  },
  [EAdvancedCouponsLayouts.tomorrowMatches]: {
    '@gte': dayjs().endOf('day').unix(),
    '@lte': dayjs().endOf('day').add(1, 'day').unix()
  }
};
